module.exports = __webpack_public_path__ + "2026310:ef9a7edf554eddff21f3/img/hero_image@2x.362b064.png";